import BaseEntity from './BaseEntity';
export default class AutoFixPullRequestFile extends BaseEntity {
    constructor(data) {
        super();
        this.fixDiff = this.parseProperty(data, 'fixDiff');
        this.fixTool = this.parseProperty(data, 'fixTool');
        this.path = this.parseProperty(data, 'path');
    }
}
